jQuery(function () {
	// Forms animations and in line validation
	const inputWrappers = document.querySelectorAll('.label-wrapper')

	function toggleClassOnFocus(e) {
		const parent = e.target.parentElement
		if (e.type === 'focus' || (e.type === 'input' && e.target.value === '')) {
			parent.classList.add('focused')
		} else if (e.type === 'blur' && e.target.value === '') {
			parent.classList.remove('focused')
		}
	}

	function clearError(e) {
		let inputControl = e.target.parentElement
		let errorDisplay = inputControl.querySelector('.error') || inputControl.parentElement.querySelector('.span-err')
		if (e.target.type === 'email') {
			if (CommonUtils.validateEmail(e.target.value)) {
				errorDisplay.innerText = ''
				inputControl.classList.remove('error')
			}
		} else {
			errorDisplay.innerText = ''
			inputControl.classList.remove('error')
		}
	}
	setTimeout(() => {
		inputWrappers.forEach(wrapper => {
			const inputs = wrapper.querySelectorAll('input[type="text"], input[type="email"], input[type="tel"], input[type="search"], input[type="number"], select, textarea')

			inputs.forEach((input: HTMLInputElement) => {
				input.addEventListener('focus', toggleClassOnFocus)
				input.addEventListener('blur', toggleClassOnFocus)
				input.addEventListener('input', clearError)
				if (input.value !== '') {
					const parent = input.parentElement
					parent.classList.add('focused')
				}
			})
		})
	}, 500)
	// Replace email input values with trimmed values
	$('input[type=\'email\']').on('blur', function () {
		if ((<HTMLInputElement>this).value) {
			var trimmedEmailVal = (<HTMLInputElement>this).value.trim();
			(<HTMLInputElement>this).value = trimmedEmailVal
		}
	});
	(<any>$('.fancybox')).fancybox({
		openEffect: 'elastic',
		openSpeed: 350,
		closeEffect: 'elastic',
		closeSpeed: 350,
		nextEffect: 'fade',
		nextSpeed: 200,
		loop: false
	});
	(<any>$('.iframe')).fancybox({
		type: 'iframe',
		maxWidth: 500,
		fitToView: false,
		width: '90%',
		autoSize: false,
		openEffect: 'elastic',
		openSpeed: 350,
		closeEffect: 'elastic',
		closeSpeed: 350
	});
	(<any>$('.inline')).fancybox({
		openEffect: 'elastic',
		openSpeed: 350,
		closeEffect: 'elastic',
		closeSpeed: 350,
		nextEffect: 'fade',
		nextSpeed: 200,
		scrolling: 'no',
		autoSize: true
	});
	(<any>$('#a_lightbox')).fancybox({ autoSize: true, scrolling: 'no' })
});
//Fancybox Lightbox End
//dilogBox
//@Author: Adarsh Kurudi
function dilogBox(dialogObj: DialogObj): void {
	var template = {
		outerWrap: '<div class="overlay signupConfirmationFocusTrap" id="dialogbox" tabindex=0 role="dialog" style=""><div class="confirmation email-lightbox" role="form"></div></div>',
		closeBtn: '<a id="dialogCloseBtn" class="icon-close" aria-label="close lightbox" ><span class="hidden">Close</span></a>',
		innerMain: '<div class="lb-content"><div class="lb-form"><h3 id="dialogMain"></h3>',
		innerSecondary: '<p id="dialogSecondary"></p>',
		confirmBtn: '<input type="button" id="dialogBtn" value="Continue Shopping" class="btn-main"/ ></div></div>'
	};
	if (!document.getElementById('dialogbox')) {
		$(template.outerWrap).prependTo('body').trigger('focus');
	} else {
		document.getElementById('dialogbox').style.display = "";
		document.getElementById('dialogbox').style.visibility = "visible";
	}
	$('.confirmation').html(template.closeBtn + template.innerMain + template.innerSecondary + template.confirmBtn);
	$('#dialogMain').text(dialogObj.mainTxt);
	$('#dialogSecondary').text(dialogObj.secondaryTxt);
	$('#dialogBtn').val(dialogObj.btnTxt);
	HAHAccessibility.trapFocus({
		container: '.signupConfirmationFocusTrap',
		closeElement: '#dialogbox',
		firstElementToFocus: '#title-container'
	});
	const dialogBtn = document.getElementById('dialogBtn');
    if (dialogBtn) {
        dialogBtn.addEventListener('click', () => {
            const dialogbox = document.getElementById('dialogbox');
            if (dialogbox) {
                dialogbox.style.visibility = 'hidden';
                dialogbox.style.display = 'none';
            }
        });
    }
	const dialogCloseBtn = document.getElementById('dialogCloseBtn');
    if (dialogCloseBtn) {
        dialogCloseBtn.addEventListener('click', (event) => {
            event.preventDefault();
            const dialogbox = document.getElementById('dialogCloseBtn');
            if (dialogbox) {
                dialogbox.style.visibility = 'hidden';
                dialogbox.style.display = 'none';
            }
        });
    }
	$('#dialogbox').on('click', function () {
		$(this).css({
			'visibility': 'hidden',
			'display': 'none	'
		});
	});
}
//End dilogBox
$(function () {
	//Include for JQuery version 1.5 and below
	jQuery.expr.pseudos.focus = function (elem: any) {
		return elem === document.activeElement && (elem.type || elem.href)
	};
	$('form').on('keypress', function (e) {
		if (e.key === 'Enter') {
			//alert($("#tSearchString").is(":focus"));
			if ($('#tSearchString').is(':focus')) {
				$('#searchSubmit').trigger('click')
				return false
			} else if ($('#sweepsName, #sweepsEmail, #sweepsCheck, #sweepsBonvoyCheck').is(':focus')) {
				$('#sweepsBtn').trigger('click')
				return false
			} else if ($('#landingPageSweepsName, #landingPageSweepsEmail, #landingPageSweepsCheck, #landingPageSweepsBonvoyCheck, #recaptcha-anchor').is(':focus')) {
				$('#landingPageSweepsBtn').trigger('click')
				return false
			} else if ($('#emailAddress1').is(':focus')) {
				$('#emailAddress1').trigger('blur')
				$('#emailAddress1btn').trigger('click')
				return false
			} else if ($('#emailAddress2').is(':focus')) {
				$('#emailAddress2').trigger('blur')
				$('#emailAddress2btn').trigger('click')
				return false
			} else if ($('#emailAddress').is(':focus')) {
				$('#emailAddress').trigger('blur');
				return false;
			} else if ($('#searchUI_tbProductName').is(':focus')) {
				doSearch()
				return false
			} else if ($('#validationNbr').is(':focus')) {
				$('#validationNbr').trigger('blur')
				$('#btn_apply').trigger('click')
				return false
			}
		}
	});
});
// On "DOMContentLoaded" (before the "load" event), calls "HAHAccessibility.init()" 
$(() => HAHAccessibility.init())